var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',{staticClass:"card-column"},[_c('Details',{attrs:{"wikiId":this.wikiId}})],1)],1),_c('v-row',[_c('v-col',{staticClass:"card-column"},[_c('Profile',{attrs:{"wikiId":this.wikiId}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }